<template>
  <layout-vertical>

    <router-view />

    <template #navbar="{ toggleVerticalMenuActive }">
      <navbar :toggle-vertical-menu-active="toggleVerticalMenuActive"/>
      <VueBottomNavigation v-if="user ? user.type === 'Pegawai': false" :options="options" v-model="selected" />
    </template>

    <!-- <app-customizer
      v-if="showCustomizer"
      slot="customizer"
    /> -->
  </layout-vertical>
</template>

<script>
import LayoutVertical from '@core/layouts/layout-vertical/LayoutVertical.vue'
// import AppCustomizer from '@core/layouts/components/app-customizer/AppCustomizer.vue'
// import { $themeConfig } from '@themeConfig'
import Navbar from '../components/Navbar.vue'
import VueBottomNavigation from 'bottom-navigation-vue'

export default {
  components: {
    // AppCustomizer,
    LayoutVertical,
    Navbar,
    VueBottomNavigation
  },
  data() {
    return {
      // showCustomizer: $themeConfig.layout.customizer,
      menuHidden: this.$store.state.appConfig.layout.menu.hidden,
      selected: 2,
      options: [
        {
          id: 1,
          icon: "fa fa-bell",
          title: "Pengajuan",
          path: { name: "pengajuan"},
        },
        {
          id: 2,
          icon: "fa fa-home",
          title: "Home",
          path: { name: "home"},
        },
        {
          id: 3,
          icon: "fa fa-user",
          title: "Profil",
          path: { name: "profil"},
        },
      ],
    }
  },
  computed: {
    user() { return this.$store.getters.user },
  },
  created() {
    if(this.user.type === "Pegawai"){
      this.$store.commit('appConfig/UPDATE_NAV_MENU_HIDDEN', true)
    }else{
      this.$store.commit('appConfig/UPDATE_NAV_MENU_HIDDEN', false)
    }
  },
  destroyed() {
    if(this.user.type === "Pegawai"){
      this.$store.commit('appConfig/UPDATE_NAV_MENU_HIDDEN', true)
    }else{
      this.$store.commit('appConfig/UPDATE_NAV_MENU_HIDDEN', false)
    }
  },
}
</script>

<style scoped>
@import "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css";

.btn-containrt_foreground{
  --color-foreground: #0d642f !important;
  width: 100% !important;
  left: 0 !important;
}

</style>
